import {authMiddleware} from "./loginAction";
import cfg, {handleResponse, handlePrepareData} from "../constants";

// mailingsAction - get mailings
export const mailingsAction = (filter, signal) => (dispatch, getState) => {
  const headers = authMiddleware(dispatch, getState);
  return fetch(cfg.base_url + '/auth/bulk-mailing-list', {
    method: "POST",
    body: JSON.stringify(filter),
    headers,
    signal
  }).then(handleResponse).then(handlePrepareData);
};

// mailingDeleteAction - delete mailing by ID
export const mailingDeleteAction = (id) => (dispatch, getState) => {
  const headers = authMiddleware(dispatch, getState);
  return fetch(cfg.base_url + '/auth/bulk-mailing/' + id + '/delete', {
    method: "DELETE",
    headers
  }).then(handleResponse).then(handlePrepareData);
};

// mailingEditAction - edit mailing by ID
export const mailingEditAction = (form) => (dispatch, getState) => {
  const headers = authMiddleware(dispatch, getState);
  return fetch(cfg.base_url + '/auth/bulk-mailing-edit', {
    method: "POST",
    body: JSON.stringify(form),
    headers
  }).then(handleResponse).then(handlePrepareData);
};
